import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class UpdateTransactionUseCase extends UseCase {
  constructor({getCurrentUserService, repository, transactionParamsRequest}) {
    super()
    this._getCurrentUserService = getCurrentUserService
    this._repository = repository
    this._transactionParamsRequest = transactionParamsRequest
  }

  getCurrentUser = async () => this._getCurrentUserService.execute()

  getUserId = async () => {
    const currentUser = await this.getCurrentUser()
    return currentUser.getId()
  }

  execute = async ({adId, buyerId, sellerId, status}) => {
    const userId = await this.getUserId()

    const requestVO = this._transactionParamsRequest({
      adId: Number(adId),
      buyerId: Number(buyerId) || userId,
      sellerId: Number(sellerId) || userId,
      status
    })
    const [error, response] = await this._repository.updateTransaction({
      requestVO
    })

    if (error) throw error

    return response
  }
}
